import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from 'src/app/shared/guards/can-deactivate.guard';
import { ApiErrorResponse } from 'src/app/shared/interfaces/api-error-response';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SubSink } from 'subsink';

import { MerchantBasicDataViewModel } from '@app/api/models';

import { MerchantActions, MerchantSelectors } from '../../store/merchant.slice';
import { MerchantBasicDataFormComponent } from './merchant-basic-data-form/merchant-basic-data-form.component';

@Component({
  selector: 'app-merchant-basic-data',
  templateUrl: './merchant-basic-data.component.html',
  styleUrls: ['./merchant-basic-data.component.scss'],
})
export class MerchantBasicDataComponent
  implements OnInit, OnDestroy, CanComponentDeactivate
{
  @ViewChild(MerchantBasicDataFormComponent)
  merchantBasicDataForm!: MerchantBasicDataFormComponent;

  isLoading$: Observable<boolean> = this.store.select(
    MerchantSelectors.isBasicDataLoading
  );

  isLoaded$: Observable<boolean> = this.store.select(
    MerchantSelectors.isBasicDataLoaded
  );
  hasLoadError$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectBasicDataLoadError
  );
  data$: Observable<MerchantBasicDataViewModel | undefined> = this.store.select(
    MerchantSelectors.selectBasicData
  );

  isUpdating$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectBasicDataUpdating
  );
  updateError$: Observable<ApiErrorResponse | undefined> = this.store.select(
    MerchantSelectors.selectBasicDataUpdateError
  );

  logoUrl$: Observable<string | undefined> = this.store.select(
    MerchantSelectors.selectMerchantLogoUrl
  );

  isLogoUpdating$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectMerchantLogoUpdating
  );

  logoUpdateError$: Observable<ApiErrorResponse | undefined> =
    this.store.select(MerchantSelectors.selectMerchantLogoUpdateError);

  private subs = new SubSink();

  constructor(
    private readonly store: Store,
    private readonly dialogService: DialogService
  ) {}

  ngOnInit() {
    this.subs.sink = this.isLoaded$.subscribe((loaded) => {
      if (!loaded) this.onLoad();
    });
  }

  onLoad() {
    this.store.dispatch(MerchantActions.loadBasicData.trigger());
  }

  onSubmit(data: { formValue: any; firstLogin: boolean }) {
    this.store.dispatch(
      MerchantActions.updateBasicData.trigger({
        data: data.formValue,
        firstLogin: data.firstLogin,
      })
    );
  }

  // TODO
  canDeactivate() {
    return this.merchantBasicDataForm.form.dirty
      ? this.dialogService.confirmUnsavedChanges()
      : true;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
